import { Switch, Route, Redirect } from 'react-router-dom';
import Layout from "./components/Layout/Layout";
import Home from "./components/screens/Home";
import SignUp from "./components/Authentication/SignUp";
import Login from './components/Authentication/Login';
import Profile from './components/screens/Profile';
import ForgetPassword from './components/screens/ForgetPassword';
import About from './components/screens/About';

function App() {
  const isToken = localStorage.getItem('token');
  return (
    <Layout>
      <Switch>
        {isToken != null && <Route path="/" exact>
          <Redirect to="/home" />
        </Route>}
        {isToken === null && <Route path="/home" exact>
          <Redirect to="/login" />
        </Route>}
        {isToken !== null && <Route path="/profile">
          <Profile />
        </Route>}
        {isToken === null && <Route path="/signup" exact>
          <SignUp />
        </Route>}
        {isToken === null && <Route path="/login">
          <Login />
        </Route>}
        {isToken === null && <Route path="/forget-password">
          <ForgetPassword />
        </Route>}
        {<Route path="/home" exact>
          <Home />
        </Route>}
        {<Route path="/about" exact>
          <About />
        </Route>}
        <Route path="*">
          <Redirect to="/home" />
        </Route>
      </Switch>
    </Layout>
  );
}

export default App;
